import { Container, Graphics, Sprite, Text } from 'pixi.js';
import AssetsManager from '../../gamma-engine/core/assets/AssetsManager';
import { container } from 'tsyringe';
import SlotMachine from '../../gamma-engine/slots/model/SlotMachine';
import { SlotMachineState } from '../../gamma-engine/slots/model/SlotMachineState';
import PopupState from '../../gamma-engine/common/model/PopupState';
import UIState from '../../gamma-engine/common/model/UIState';
import { UIPanelEvent } from '../../gamma-engine/common/control/event/UIPanelEvent';
import ControlEvent from '../../gamma-engine/core/control/event/ControlEvent';


export default class Replay extends Container {
    private logoContainer: Container
    private logoBg: Graphics
    private rGraphics: Graphics;
    private replayText: Text;

    private pauseContainer: Container
    private pauseBg: Graphics
    private pauseText: Text
    private intervalObj: number | undefined;
    private sm: SlotMachine;

    constructor() {
        super();
        this.logoContainer = new Container()
        this.sm = container.resolve(SlotMachine);

        this.logoBg = new Graphics()
        this.logoBg.beginFill(0x000000);
        this.logoBg.drawRoundedRect(-125, -40, 250, 80, 20);
        this.logoBg.endFill();

        this.rGraphics = new Graphics();
        this.rGraphics.beginFill(0xFF0000, 1);
        this.rGraphics.drawCircle(-10, -10, 20);
        this.rGraphics.endFill();
        this.rGraphics.position.set(-this.logoBg.width / 2 + this.rGraphics.width + 10, 10)


        this.replayText = new Text(AssetsManager.translations.get("replay"), {
            fontFamily: 'Arial',
            fontSize: 38,
            fontWeight: 'bold',
            fill: 0xFFFFFF
        });
        this.replayText.anchor.set(0, 0.5)
        this.replayText.position.set(this.rGraphics.x + this.rGraphics.width / 2, 0);
        this.logoContainer.addChild(this.logoBg, this.rGraphics, this.replayText)
        this.addChild(this.logoContainer);

        this.logoContainer.position.set(130, 50)

        this.pauseContainer = new Container()

        this.pauseBg = new Graphics()
        this.pauseBg.beginFill(0xFFFFFF);
        this.pauseBg.drawRoundedRect(-100, -35, 200, 70, 20);
        this.pauseBg.endFill();


        this.pauseText = new Text(AssetsManager.translations.get("pause"), {
            fontFamily: 'Arial',
            fontSize: 38,
            fontWeight: 'bold',
            fill: 0x000000,
            align: 'right'
        });
        this.pauseText.anchor.set(0.5)
        this.pauseContainer.addChild(this.pauseBg, this.pauseText)

        this.pauseContainer.eventMode = 'static';
        this.pauseContainer.cursor = 'pointer';
        this.pauseReplay = this.pauseReplay.bind(this);
        this.pauseContainer.on('pointerdown', this.pauseReplay);

        this.addChild(this.pauseContainer);


        window.addEventListener('resize', this.onResize.bind(this))
        this.onResize()
        this.remove()
    }

    private pauseReplay(): void {
        const uiState: UIState = container.resolve(UIState);
        const popupState: PopupState = container.resolve(PopupState);
        if (!this.sm.pauseAfterSpinRound) {
            this.sm.pauseAfterSpinRound = !this.sm.pauseAfterSpinRound;
            this.pauseText.text = AssetsManager.translations.get("play");
            this.sm.isPlayButtonActive = false;
        } else {
            if(uiState.activePanel || popupState.activePopup) {
                new ControlEvent(UIPanelEvent.HIDE_POPUP).dispatch();
                return;
            }
            this.sm.pauseAfterSpinRound = !this.sm.pauseAfterSpinRound;
            this.pauseText.text = AssetsManager.translations.get("pause")
            if(this.sm.isPlayButtonActive)
                this.sm.currentState = SlotMachineState.FREE_SPINS;
        }
    }

    public add(): void {
        clearInterval(this.intervalObj)
        this.visible = true
        this.intervalObj = window.setInterval(() => {
            this.logoContainer.alpha = this.logoContainer.alpha ? 0 : 1
        }, 250);
    }


    public remove(): void {
        this.visible = false;
        this.sm.pauseAfterSpinRound = false;
        this.pauseText.text = AssetsManager.translations.get("pause")
        if (this.intervalObj)
            clearInterval(this.intervalObj)
    }

    private onResize(): void {
        if (window.innerWidth > window.innerHeight) {
            this.logoContainer.x = 130;
            this.pauseContainer.position.set(1800, 50)
        }
        else {
            this.logoContainer.x = 130;
            this.pauseContainer.position.set(1000, 50)
        }
    }

}